import { IHttpResponseHandler } from  "@/interfaces/IHttp";
import { injectable } from "inversify";

@injectable()
export class HttpResponseHandler implements IHttpResponseHandler {
    unauthorized(){
 
    }
}